import { providesList } from '@helpers/index';
import humps from 'lodash-humps-ts';
import BaseService from '../base';
import {
  SiteWorkerAddParamsProps,
  SiteWorkerParamsProps,
  SiteWorkersApiProps,
  SiteWorkerPhotosParams,
  SiteWorkerPhotosApiProps,
} from './types';

class SiteWorker extends BaseService {
  addAnnotation() {
    return {
      query: ({ ...body }: SiteWorkerAddParamsProps) => ({
        url: '/notes',
        method: 'POST',
        body,
      }),
      invalidatesTags: [
        { type: this.tagType, id: 'LIST' }, { type: 'Worker' }, { type: 'SiteWorker' },
      ],
    };
  }

  getSiteWorkers() {
    return {
      query: ({ id, ...params }: SiteWorkerParamsProps) => ({
        url: `sites/${id}/site-workers`,
        params,
      }),

      providesTags: (result: SiteWorkersApiProps | undefined) => (
        providesList(result?.workers, this.tagType)
      ),
    };
  }

  // eslint-disable-next-line class-methods-use-this
  getSiteWorkerPhotos() {
    return {
      query: ({
        siteWorkerId,
        page = 0,
        pageSize = 12,
        forAccessId,
      }: SiteWorkerPhotosParams) => ({
        url: `site-workers/${siteWorkerId}/photos`,
        params: {
          page,
          page_size: pageSize,
          for_access_id: forAccessId,
        },
      }),
      transformResponse: (response: unknown) => humps(response) as SiteWorkerPhotosApiProps,
    };
  }
}

export default new SiteWorker('site-workers', 'SiteWorker');
